import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { createDependencyInjectableComponent } from "@faire/retailer-visitor-shared/app/_lib/dependencyInjectableComponent";
import { useMaybePrefetchDiscoverPage } from "@faire/retailer-visitor-shared/views/discover/__internal__/prefetch/useMaybePrefetchDiscoverPage";
import { Route } from "@faire/web-api--source/Route";
import { props as discoverRouteProps } from "@faire/web-api--source/routes/discover/searchTerm";
import React, { lazy } from "react";
export var renderDiscoverPageRoute = function() {
    /* For SEO purpose, we want support URL `/discover/candle` besides
     * `/search?q=candle` but still want the q from query param to take precedence
     * ie, `/discover/candle?q=notCandle` will display results for query
     * `notCandle` instead of `candle`
     */ return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, discoverRouteProps), {
        component: LazyDiscoverPageWithClientSidePrefetch
    }));
};
var LazyDiscoverPageWithClientSidePrefetch = function() {
    useMaybePrefetchDiscoverPage();
    var DiscoverPage = useDiscoverPage();
    return /*#__PURE__*/ _jsx(DiscoverPage, {});
};
var LazyDiscoverPageNoPrefetch = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "discover-page" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DiscoverPage").then(function(m) {
        return {
            default: m.DiscoverPage
        };
    });
});
var _createDependencyInjectableComponent = createDependencyInjectableComponent(LazyDiscoverPageNoPrefetch), useDiscoverPage = _createDependencyInjectableComponent.useDependencyInjectableComponent;
